<template>
  <div>
    <b-card 
      title="Binary - Base 2" 
      header="Prefix 'b'"
      footer="Symbols = {0, 1}">
      <b-card-body>
        <table>
          <tr>
            <td>b1101</td>
            <td> = </td>
            <td> 1 &times; 2<sup>3</sup> + 1 &times; 2<sup>2</sup> + 0 &times; 2<sup>1</sup> + 1 &times; 2<sup>0</sup> </td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card 
      title="Decimal - Base 10" 
      header="Prefix '#'"
      footer="Symbols = {0, 1, 2, 3, 4, 5, 6, 7, 8, 9}">
      <b-card-body>
        <table>
          <tr>
            <td>#1234</td>
            <td> = </td>
            <td> 1 &times; 10<sup>3</sup> + 2 &times; 10<sup>2</sup> + 3 &times; 10<sup>1</sup> + 4 &times; 10<sup>0</sup> </td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card 
      title="Hexadecimal - Base 16" 
      header="Prefix 'x'"
      footer="Symbols = {0, 1, 2, 3, 4, 5, 6, 7, 8, 9, A, B, C, D, E, F}">
      <b-card-body>
        <table>
          <tr>
            <td>x1DF3 (also 0x1DF3)</td>
            <td> = </td>
            <td> 1 &times; 16<sup>3</sup> + D &times; 16<sup>2</sup> + F &times; 16<sup>1</sup> + 3 &times; 16<sup>0</sup> </td>
          </tr>
        </table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'bases'
}
</script>



// WEBPACK FOOTER //
// src/components/bases.vue